import { createSelector } from 'reselect';
import { initialStateApplications } from '../store/models/applications';

const applicationsSelector = state => state.applications || initialStateApplications;

const selectApps = () => createSelector(applicationsSelector, globalState => globalState.data);

const selectLoading = () =>
  createSelector(applicationsSelector, globalState => globalState.isLoading);

export { selectApps, selectLoading };
